import { gql } from "@apollo/client"
import { DateTime } from "luxon"
import styles from "../../../styles/Participant-Employment.module.css"

export function showError(toast, mge, errors) {
  console.log(`${mge}: ${JSON.stringify(errors)}`)
  toast.current.show({
    severity: "error",
    detail: mge,
    life: 3000,
  })
}

export const Actions = {
  Add: 0,
  Edit: 1,
  View: 2,
  End: 3,
}
export const InactiveStatuses = {
  Discharged: "Inactive Discharged",
  Referrals: "Inactive Referrals",
  Kiosk: "Kiosk Member",
}
export const DateTimeFormat = "MM/dd/yyyy hh:mm a"
export const DateFormat = "MM/dd/yyyy"
export const TimeFormat = "hh:mm a"

export const convertToLocalDateTime = (date) =>
  DateTime.fromISO(date, { zone: "utc" }).toLocal().toJSDate()
export const formatToLocalDateTime = (date, format) =>
  DateTime.fromISO(date, { zone: "utc" }).toLocal().toFormat(format)

export const getDuration = (startTime, endTime) => {
  startTime = DateTime.fromISO(startTime, { zone: "utc" }).toLocal()
  endTime = DateTime.fromISO(endTime, { zone: "utc" }).toLocal()
  const duration = endTime
    .diff(startTime, ["hours", "minutes", "seconds"])
    .toObject()
  let duration_str = ""

  for (const [unit, value] of Object.entries(duration)) {
    if (value > 0) {
      duration_str +=
        value > 1 ? `${value} ${unit} ` : `${value} ${unit.slice(0, -1)} `
    }
  }

  return duration_str
}

export const getStartAndEndTime = (startTimeDt, endTimeDt) => {
  const startTime = formatToLocalDateTime(startTimeDt, TimeFormat)
  const endTime = formatToLocalDateTime(endTimeDt, TimeFormat)
  return `${startTime} - ${endTime}`
}

export const getStartAndEndDate = (startDateDt, endDateDt, type) => {
  let startDate = "",
    endDate = ""
  if (type === "iso") {
    const startYear = DateTime.fromISO(startDateDt).year
    const endYear = DateTime.fromISO(endDateDt).year
    startDate = !isNaN(startYear)
      ? DateTime.fromISO(startDateDt).toFormat(DateFormat)
      : "Invalid DateTime"
    endDate = !isNaN(endYear)
      ? DateTime.fromISO(endDateDt).toFormat(DateFormat)
      : "Invalid DateTime"
  } else {
    startDate = DateTime.fromJSDate(startDateDt).toFormat(DateFormat)
    endDate = DateTime.fromJSDate(endDateDt).toFormat(DateFormat)
  }

  return startDate !== "Invalid DateTime" && endDate !== "Invalid DateTime"
    ? `${startDate} - ${endDate}`
    : ""
}

export const formatDate = (date) => {
  //Asure that date has time 00:00:00
  const formattedDate = DateTime.fromJSDate(date).set({
    hour: 0,
    minute: 0,
    second: 0,
    millisecond: 0,
  })
  return formattedDate.toJSDate()
}

export const addOneMinute = (date) => {
  return DateTime.fromJSDate(date).plus({ minutes: 1 }).toJSDate()
}

export const substractOneMinute = (date) => {
  return DateTime.fromJSDate(date).minus({ minutes: 1 }).toJSDate()
}

export const formatDateAndDuration = (date, startTime, endTime) => {
  const formattedDate = formatDate(date)
  //Assure that start and end time are from same day as date
  const dateObj = DateTime.fromJSDate(date).toObject()
  const formattedStartTime = DateTime.fromJSDate(startTime)
    .set({ day: dateObj.day, month: dateObj.month, year: dateObj.year })
    .toJSDate()
  const formattedEndTime = DateTime.fromJSDate(endTime)
    .set({ day: dateObj.day, month: dateObj.month, year: dateObj.year })
    .toJSDate()

  return { formattedDate, formattedStartTime, formattedEndTime }
}

export const requieredFieldIsMissing = (field) => {
  if (field === null) return true
  if (
    (typeof field === "string" || field instanceof String) &&
    field.trim() === ""
  )
    return true
  return false
}

export const renderRequireFieldErrorMessage = (field, mge) => {
  if (requieredFieldIsMissing(field))
    return <small className="p-error">{mge}</small>
  return null
}

const capitalizeFirstLetter = (string, html) => {
  if (html) {
    string = "" + string
    return string.replace(/(<\w+>)*(\w).*/, (match, p1, p2) => {
      return match.replace(p1 + p2, p1 + p2.toUpperCase())
    })
  } else {
    return string && string.length > 1
      ? string.charAt(0).toUpperCase() + string.slice(1)
      : string
  }
}

export const renderCareerViewTable = (section, filter, data) => {
  const sectionFiltered = Object.entries(section)
    .map((w) => {
      return w[1]
    })
    .filter((w) => w.value?.startsWith(filter))
  return sectionFiltered.map((s) => {
    if (!s.skip) {
      return (
        <table id={`${s.label}`} className={styles.table}>
          <tbody>
            <tr>
              <th>{s.label}</th>
            </tr>
            <tr>
              {renderTableDataCell({
                type: s.aux_type ? s.aux_type : s.type ? s.type : "html",
                label: s.label,
                value: data
                  ? data[
                      s.aux_value
                        ? s.aux_value.replace("_", "")
                        : s.value.replace("_", "")
                    ]
                  : "",
              })}
            </tr>
          </tbody>
        </table>
      )
    }
  })
}
export const renderTableDataCell = (item) => {
  if (item.type === "date") {
    return (
      <td key={item.label.replaceAll(" ", "_").toLowerCase()}>
        {item.value != null
          ? formatToLocalDateTime(item.value, DateFormat)
          : ""}
      </td>
    )
  }
  if (item.type === "datetime") {
    return (
      <td key={item.label.replaceAll(" ", "_").toLowerCase()}>
        {item.value != null
          ? formatToLocalDateTime(item.value, DateTimeFormat)
          : ""}
      </td>
    )
  }
  if (item.type === "staff") {
    return (
      <td key={item.label.replaceAll(" ", "_").toLowerCase()}>
        {item.value != null ? `${item.value.first} ${item.value.last}` : ""}
      </td>
    )
  }
  if (item.type === "html") {
    return (
      <td
        className={styles.html_cell}
        key={item.label.replaceAll(" ", "_").toLowerCase()}
        dangerouslySetInnerHTML={{
          __html:
            item.value != null ? capitalizeFirstLetter(item.value, true) : "",
        }}
      />
    )
  }
  return (
    <td key={item.label.replaceAll(" ", "_").toLowerCase()}>
      {item.value != null ? capitalizeFirstLetter(item.value) : ""}
    </td>
  )
}

export const getActiveReferral = (referrals) => {
  if (referrals.length > 0) {
    //API returns referrals ordered by completedAt asc so the first one is the active one
    const firstOne = referrals[0]
    if (firstOne.completedAt == null) {
      return firstOne
    }
  }
  return null
}

export const updateActiveReferral = (referrals, activeReferral) => {
  if (referrals.length > 0) {
    //Replace first element
    referrals.splice(0, 1, activeReferral)
    return referrals
  }
}

export const deleteActiveReferral = (referrals) => {
  if (referrals.length > 0) {
    //Delete first element
    referrals.shift()
    return referrals
  }
}

export const groupBy = (array, key) => {
  return array?.reduce((result, currentValue) => {
    ;(result[currentValue[key]] = result[currentValue[key]] || []).push(
      currentValue
    )
    return result
  }, {})
}
export const groupTable = (array, title) => {
  return (
    <div className={styles.table_group}>
      {title && (
        <h3
          className={styles.view_subtitle}
          style={{
            color: "#383838",
            fontWeight: "600",
          }}
        >
          {title}
        </h3>
      )}
      {Object.values(array).map((group, groupIndex) => {
        return (
          <table
            className={styles.table}
            key={`transition_plan_table_${groupIndex}`}
          >
            <thead>
              <tr>
                {group.map((item, index) => (
                  <th key={index}>{item.label}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              <tr key={`transition${groupIndex}`}>
                {group.map((item, index) => renderTableDataCell(item, index))}
              </tr>
            </tbody>
          </table>
        )
      })}
    </div>
  )
}

export const GET_USER = gql`
  query user($staff_id: ID!, $organization_id: ID!) {
    user(staff_id: $staff_id, organization_id: $organization_id) {
      staff_name_first
      staff_name_last
    }
  }
`
export const validateEmail = (email) => {
  return /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email)
}

export const inactiveParticipant = (participant_membership_status) => {
  return (
    participant_membership_status === InactiveStatuses.Discharged ||
    participant_membership_status === InactiveStatuses.Referrals ||
    participant_membership_status === InactiveStatuses.Kiosk
  )
}
